/**
 * Chain tag map — derived from @b3/chain-registry (single source of truth).
 * To add chain tags, edit the "tags" field in packages/chain-registry/chains.json.
 */
export { CHAIN_TAG_MAP } from "@b3/chain-registry";
